import React, { useState, useEffect } from "react";
import { Loader } from "rsuite";
import {
  getWorklistCounters,
} from "~/services/supervisor.services";


const statusCounters = () => {
  const [listCounter, setlistCounter] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const cards = [
    { label: "Total", key: "total", color: "blue", Loader: "border-blue-700" },
    { label: "Received", key: "received", color: "green", Loader: "border-green-700" },
    { label: "Processed", key: "processed", color: "yellow", Loader: "border-yellow-700" },
    { label: "Pending", key: "pending", color: "cyan", Loader: "border-cyan-700" },
    { label: "Exception", key: "exceptionagent", color: "red", Loader: "border-red-700" },
    { label: "Hold", key: "hold", color: "blue", Loader: "border-blue-700" },
  ];

  const data = listCounter?.[0] || {};
  const total =
    (data?.received || 0) +
    (data?.processed || 0) +
    (data?.pending || 0) +
    (data?.exceptionagent || 0) +
    (data?.hold || 0);

  const fetchCounterData = async () => {
    setLoading(true);
    const { data, status } = await getWorklistCounters();
    if (status) {
      setlistCounter((data as any)?.data);
      console.log("Counter data received:", data);
    }
    setLoading(false);
  };

  const renderValue = (value: any, color?: string) => {
    if (loading) return <div className={`w-5 h-5 border-2 ${color} border-t-transparent rounded-full animate-spin`}></div>;
    return value ?? 0;
  };

  useEffect(() => {
    void fetchCounterData();
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      void fetchCounterData();
    }, 120000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div className="relative my-4">
      <div className="grid grid-cols-6 gap-10">
        {cards.map((card) => {
          const value =
            card.key === "total" ? total : data[card.key];

          return (
            <div
              key={card.key}
              className={`bg-${card.color}-200 ring-2 ring-${card.color}-500 rounded-lg p-3 flex justify-between`}
            >
              <span className="font-semibold text-sm">
                {card.label}
              </span>
              <span className="font-semibold">
                {renderValue(value, card.Loader)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default statusCounters;
